import {faChevronLeft, faTimes} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Description, Title} from '@radix-ui/react-dialog';
import clsx from 'clsx';

type Props = React.ComponentPropsWithRef<typeof Title> & {
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  onBack?: React.MouseEventHandler<HTMLButtonElement>;
  description?: string;
};
export const SleeveTitle = (
  {
    ref: forwardedRef,
    children,
    description,
    className,
    onClose,
    onBack,
    ...props
  }: Props & {
    ref?: React.RefObject<HTMLHeadingElement>;
  }
) => (<div className="bg-slate2 px-4 py-6 sm:px-6">
  <div className="grid grid-cols-[auto_1fr_auto] items-center gap-4">
    {onBack && (
      <div className="flex h-7 items-center">
        <button
          type="button"
          className="relative rounded-md text-slate11 hover:text-slate12 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-slate12"
          onClick={onBack}
        >
          <span className="sr-only">Back</span>
          <FontAwesomeIcon
            icon={faChevronLeft}
            size="sm"
            aria-hidden="true"
          />
        </button>
      </div>
    )}

    <Title
      ref={forwardedRef}
      {...props}
      className={clsx('text-base font-semibold text-slate12', className)}
    >
      {children}
    </Title>

    <div className="col-3 flex h-7 items-center">
      <button
        type="button"
        className="relative rounded-md text-slate11 hover:text-slate12 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-slate12"
        onClick={onClose}
      >
        <span className="sr-only">Close</span>
        <FontAwesomeIcon icon={faTimes} aria-hidden="true" />
      </button>
    </div>
  </div>
  {description && (
    <div className="mt-1">
      <Description className="text-sm text-slate11">
        {description}
      </Description>
    </div>
  )}
</div>);

SleeveTitle.displayName = 'SleeveTitle';
